import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { StorageService } from '../../core/services/storage/storage.service';
import { WebsocketService } from '../../services/websocket/websocket.service';

export interface PurchaseSuccessComponent {
  guestCheckoutResponse?: { set: (value: unknown) => void };
  isNavigatingToInstallation?: boolean;
}

@Injectable({ providedIn: 'root' })
export class PurchaseSuccessDeactivateGuard implements CanDeactivate<PurchaseSuccessComponent> {
  private readonly websocketService = inject(WebsocketService);
  private readonly storageService = inject(StorageService);

  canDeactivate(
    component: PurchaseSuccessComponent,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean {
    if (nextState?.url?.includes('/installation')) {
      component.isNavigatingToInstallation = true;
      return true;
    }

    this.websocketService.clearPaymentEvents();
    this.storageService.clearCheckoutData();

    // Clear guest checkout response if present
    component.guestCheckoutResponse?.set(null);

    return true;
  }
}
